<template>
  <basic-container>
    <el-tabs v-model="activeName" @tab-click="handleClick" style="height: 100%">
      <el-tab-pane label="通话统计分析" name="thtjfx" style="height: 100%">
        <div class="accountManagement" v-if="activeName === 'thtjfx'">
          <div class="content_box">
            <div class="search_box">
              <div style="margin-top: 6px">
                <el-form :inline="true" :model="formData" class="demo-form-inline" size="mini" @submit.native.prevent>
                  <el-row>
                    <el-col :span="16">
                      <el-form-item label="员工姓名">
                          <el-input v-model="formData.talkUser" type="primary" placeholder="请输入员工姓名"></el-input>
                      </el-form-item>
                      <el-form-item label="呼叫时间">
                        <el-date-picker v-model="formData.talkDate" type="date" placeholder="选择呼叫时间" value-format="yyyy-MM-dd"></el-date-picker>
                      </el-form-item>
                      <el-form-item>
                        <el-button type="primary" @click="onSearch" icon="el-icon-search">查询</el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </div>
            <div class="productContent">
              <table class="layui-table myTable" v-html="tableData">

              </table>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="费用统计分析" name="fytjfx" style="height: 100%">
        <div class="accountManagement" v-if="activeName === 'fytjfx'">
          <div class="content_box">
            <div class="search_box">
              <div style="margin-top: 6px">
                <el-form :inline="true" :model="formData" class="demo-form-inline" size="mini" @submit.native.prevent>
                  <el-row>
                    <el-col :span="16">
                      <el-form-item label="员工姓名">
                        <el-input v-model="formData.expenseUser" type="primary" placeholder="请输入员工姓名"></el-input>
                      </el-form-item>
                      <el-form-item label="时间">
                        <el-date-picker v-model="formData.date" type="month" placeholder="选择时间" value-format="yyyy-MM"></el-date-picker>
                      </el-form-item>
                      <el-form-item>
                        <el-button type="primary" @click="onSearch" icon="el-icon-search">查询</el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </div>
            <div class="productContent">
              <table class="layui-table myTable" v-html="tableData">

              </table>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </basic-container>
</template>

<script>
    import {getPayRecords} from '@/api/customer/recordPhone';
    export default {
        name: "recordStatistics",
        data() {
          return {
            activeName: 'thtjfx',
            tableData:"",
            formData:{
              date:"",
              expenseUser:"",
              talkDate:"",
              talkUser:"",
              type:"talk",
            }
          }
        },
        methods: {
            handleClick() {
                if (this.activeName == 'thtjfx'){
                    this.formData.type = 'talk'
                }else{
                  this.formData.type = 'expense'
                }
                this.getList()
            },
            onSearch(){
                this.getList()
            },
            getList(){
                let Obj = {};
                if (this.activeName == 'thtjfx'){
                  Obj.talkDate = this.formData.talkDate;
                  Obj.talkUser = this.formData.talkUser;
                  Obj.type = this.formData.type;
                }else{
                  Obj.date = this.formData.date;
                  Obj.expenseUser = this.formData.expenseUser;
                  Obj.type = this.formData.type;
                }
                getPayRecords( Object.assign({}, Obj)).then(res => {
                    console.log(res.data.data);
                    if (this.activeName == 'thtjfx'){
                        this.tableData = res.data.data[0]
                    }else{
                        this.tableData = res.data.data[1]
                    }
                });
            }
        },
        mounted() {
            let a = new Date(),
            year = a.getFullYear(),
            month = a.getMonth()+1 < 10 ? "0"+(a.getMonth()+1) : a.getMonth()+1,
            date = a.getDate() < 10 ? "0"+a.getDate() : a.getDate();
            this.formData.talkDate = year + '-' + month + '-' + date;
            this.formData.date = year + '-' + month;
            this.getList();
        },
    }
</script>

<style scoped lang="scss">
  @import'/cdn/xiaosheng/layui.css';
  .accountManagement {
    height: calc(100% - 30px);
    padding-bottom: 10px !important;

    .content_box {
      display: flex;
      flex-direction: column;
      background: #fff;
      width: auto;
      height: 100%;
      border-radius: 4px;
      box-sizing: border-box;
      padding: 15px;

      .search_box {
        margin-bottom: 20px;
      }

      .productContent {
        height: calc(100% - 100px);
        /*flex: 1;*/
        /*display: flex;*/
      }
    }

    ::v-deep .el-table th.el-table__cell > .cell {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    ::v-deep .layui-table thead tr,.layui-table thead td{
      color: #fff;
      background: #40a9ff;
    }
  }
</style>
